import posthog from 'posthog-js'

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(
      process.env.VUE_APP_PUBLIC_POSTHOG_KEY,
      {
        api_host: process.env.VUE_APP_PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
      }
    )
  },
}
